module.exports = __webpack_public_path__ + "static/media/login-ill2.06ca6c23.svg";